import axios from "axios";
import { UserCredential } from "firebase/auth";
import { User as AppUser } from "../../shared/types/User";
import { createHttpConfig } from './common';
import { advertizerApiHost } from '../../constants/envs';

export const createUser = async (userCreds: UserCredential): Promise<AppUser> => {
  const { user } = userCreds;
  const response = await axios.post(advertizerApiHost + '/api/users', {
    email: user.email
  }, {
    ...createHttpConfig(await user.getIdToken()),
  });
  return response.data;
}
